// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"732":"f0dc28fc","977":"b60a116e"}[chunkId] + ".chunk.js");